import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ReportLayer from "../components/ReportLayer";

const ReportPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Report Assets" />

        {/* TableDataLayer */}
        <ReportLayer />

      </MasterLayout>

    </>
  );
};

export default ReportPage; 
